import Like from "/public/images/icons/like.svg";
import HomeSvg from "/public/images/NewAllGames/icons/home.svg";
import Cherry from "/public/images/NewAllGames/icons/cherry.svg";
import { GamesTabsPathNames } from "types/games/main";
import { useAppContext } from "contexts";
import { useMemo } from "react";
import { Flame, Rocket } from "lucide-react";
import { Target } from "layout/HeaderComponent/components/icons";

export function useGamesPageNavItems() {
  const { profile } = useAppContext();
  const navItems = useMemo(
    () => [
      { path: GamesTabsPathNames.LOBBY, label: "Lobby", icon: <HomeSvg /> },
      { path: GamesTabsPathNames.WREWARDS_HOT, label: "Hot Games", icon: <Flame /> },
      { path: GamesTabsPathNames.SLOTS, label: "Slots", icon: <Cherry /> },
      { path: GamesTabsPathNames.NEW_RELEASES, label: "New Releases", icon: <Rocket /> },
      { path: GamesTabsPathNames.CHALLENGES, label: "Challenge Games", icon: <Target /> },
      ...(profile
        ? [{ path: GamesTabsPathNames.FAVORITE_SLOTS, label: "Favorite Slots", icon: <Like /> }]
        : []),
    ],
    [profile]
  );

  return { navItems };
}
